import axios from "./constant";

axios.defaults.withCredentials = true;


export const getallDistrictsChatbot = async () =>
  await axios
    .get("/get_all_districts_chatbot")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });
export const getdistictNameChatbot = async (data) =>
  await axios
    .get("/get_all_districts_chatbot")
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

    export const getAllBlocksFromDistrictChatbot = async (District) =>
  await axios
    .get(`/get_block_from_district_chatbot?district_code=${District}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getGPFromDistrictAndBlockChatbot = async (District, Block) =>
  await axios
    .get(
      `/get_gp_from_block_and_district_chatbot?district_code=${District}&block_code=${Block}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getVillageFromGpBlockAndDistrictChatbot = async (District, Block, GP) =>
  await axios
    .get(
      `/get_village_from_gp_block_and_district_chatbot?district_code=${District}&block_code=${Block}&gp_code=${GP}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

export const getSchoolFromVillageChatbot = async (Village) =>
  await axios
    .get(`/get_school_name_gmid_chatbot?gm_id=${Village}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return "Error - " + error;
    });

